import {
  FormColumn,
  FormResultReport,
} from 'components/registration/v2/RegistrationParticipantList';

export enum LoadingType {
  GetFormResults,
  GetColumns,
  GetFilters,
  GetUniqueRegistrants,
}

export interface RegParticipantState {
  // Stores loading states for various parts of the page
  loading: Record<LoadingType, boolean>;
  // Stores the filters that are currently selected by the user
  activeFilters: Record<string, string[]>;
  // Stores all available filters
  filters: Function[];
  // The search term the user has entered
  searchTerm: string;
  exportModalTitle: string;
  columns: FormColumn[];
  // The names of the columns that the user has selected to display.
  selectedColumns: string[];
  // The main participant form result data to display in the table
  formResults: FormResultReport;
}

export enum ActionType {
  SetLoading,
  SetFormResults,
  SetActiveFilters,
  SetSearchTerm,
  SetFilters,
  SetExportModalTitle,
  SetColumns,
  SetSelectedColumns,
}

export type SetFormResultPayload = {
  formResults: FormResultReport;
};

export type SetActiveFiltersPayload = {
  activeFilters: Record<string, string[]>;
};

export type SetFiltersPayload = {
  filters: Function[];
};

export type SetExportModalTitlePayload = {
  exportModalTitle: string;
};

export type SetColumnsPayload = {
  columns: FormColumn[];
};

export type SetSearchTermPayload = {
  searchTerm: string;
};

export type SetLoadingPayload = {
  loadingType: LoadingType;
  isLoading: boolean;
};

export type SetSelectedColumnsPayload = {
  // Sets the names of the selected columns
  selectedColumns: string[];
  // If true, then we are setting the selected columns from the cache.
  fromCache?: boolean;
};
